import { useTranslation } from "react-i18next";
import { Link } from "react-router-dom";
import "./Services.css";

function Services() {
  const { t } = useTranslation();

  return (
    <section className="services" id="services">

      <div className="services-heading">

        <span className="services-label">
          {t("services.label")}
        </span>

        <h2>
          {t("services.title1")}
          <br />
          <span>{t("services.title2")}</span>
        </h2>

        <div className="services-divider">
          <span></span>
          <i>✦</i>
          <span></span>
        </div>

      </div>


      {/* Main Circles */}

      <div className="services-main-circles">

        {/* Photography */}

        <Link
          to="/photography"
          className="main-service-circle photography-service"
        >

          <div className="service-circle-overlay"></div>

          <div className="service-circle-content">

            <span className="service-number">
              01
            </span>

            <h3>
              {t("services.photography")}
            </h3>

            <div className="service-small-line">
              <span></span>
              <i>✦</i>
              <span></span>
            </div>

            <p>
              {t("services.photographyText")}
            </p>

            <div className="service-arrow">
              ↗
            </div>

          </div>

        </Link>


        {/* Rental */}

        <Link
          to="/rental"
          className="main-service-circle rental-service"
        >

          <div className="service-circle-overlay"></div>

          <div className="service-circle-content">

            <span className="service-number">
              02
            </span>

            <h3>
              {t("services.rental")}
            </h3>

            <div className="service-small-line">
              <span></span>
              <i>✦</i>
              <span></span>
            </div>

            <p>
              {t("services.rentalText")}
            </p>

            <div className="service-arrow">
              ↗
            </div>

          </div>

        </Link>

      </div>

    </section>
  );
}

export default Services;